import Icon from '../components/Icon.vue'

Icon.register({
  'step-forward': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12v-176.4l-195.5 181c-20.6 17.1-52.5 2.8-52.5-24.6v-384c0-27.4 31.9-41.7 52.5-24.6l195.5 179.9v-175.3c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z'
      }
    ]
  }
})
